<template>
  <div>
    <ol class="breadcrumb float-xl-right">
      <li class="breadcrumb-item active"><a href="javascript:;">GLP</a></li>
    </ol>
    <h1 class="page-header">Módulo GLP</h1>
    <div class="card border-0">
      <div class="card-body">
        <button
          v-show="nuevoGlp == 0"
          type="button"
          class="btn btn-warning"
          @click="
            nuevoGlp = 1;
            nuevo = true;
            duplicar = false;
          "
        >
          <i class="fa fa-plus"></i> Nuevo Cambio a GLP
        </button>
        &nbsp;
        <b-button v-show="nuevoGlp == 0" v-b-modal.modalBuscador
          >Buscar Glp+Trimovil</b-button
        >
        &nbsp;
        <button
          v-show="nuevoGlp == 1"
          type="button"
          class="btn btn-danger animated fadeIn"
          @click="
            nuevoGlp = 0;
            duplicar = false;
          "
        >
          <i class="fa fa-list"></i> Ver Listado
        </button>
      </div>
      <procesando :tipo="1" v-if="proceso" />
    </div>
    <div
      v-show="
        nuevoGlp == 0 && !proceso && this.$store.state.usuario.idtipo == '2'
      "
      class="row"
    >
      <div class="col-lg-4">
        <!--<local :todo="'Todo'" :valor_entrada="localSeleccionado" v-model="localSeleccionado"
						@evento="localSeleccionado=$event;cargaForzada()" />-->
        <personal
          :valor_entrada="personalSeleccionado"
          v-model="personalSeleccionado"
          @evento="
            personalSeleccionado = $event;
            cargaForzada();
          "
        />
      </div>
      <div class="col-lg-4">
        <anios
          :todo="'Todo'"
          :valor_entrada="anioSeleccionado"
          v-model="anioSeleccionado"
          @evento="
            anioSeleccionado = $event;
            cargaForzada();
          "
        />
      </div>
      <div class="col-lg-4">
        <meses
          :todo="'Todo'"
          :valor_entrada="mesSeleccionado"
          v-model="mesSeleccionado"
          @evento="
            mesSeleccionado = $event;
            cargaForzada();
          "
        />
      </div>
    </div>

    <div class="row animated fadeIn" v-show="nuevoGlp == 0 && !proceso">
      <div class="col-xl-12">
        <registros
          ref="registros"
          :query="queryConModal"
          :search="true"
          :porPagina="porPagina"
          :local="localSeleccionado"
          :field="'Id'"
          :columns="columns2"
          @eliminar="confirmar($event)"
          @editar="
            nuevoGlp = 1;
            glp = { ...$event };
            nuevo = false;
          "
          @duplicar="
            nuevoGlp = 1;
            glp = { ...$event };
            nuevo = false;
            duplicar = true;
          "
          :placeholder="'Buscar por certificado o propietario'"
          :url="
            this.URL_BASE() +
            'glp/search/' +
            personalSeleccionado +
            '/' +
            this.$store.state.usuario.idtipo +
            '/' +
            localSeleccionado +
            '/' +
            anioSeleccionado +
            '/' +
            mesSeleccionado
          "
        >
          <template v-slot:dias_pendientes="slotProps">
            <dias_pendientes
              :registro="slotProps.dias_pendientes"
              :tipo="'GLP'"
            />
          </template>
          <template v-slot:cantidad_duplicados="slotProps">
            <button
              type="button"
              @click="
                cargandoInfoPlacaDuplicada(
                  slotProps.cantidad_duplicados.placa_rodaje
                );tempBoletaInformativaState={}
              "
              v-b-modal.modalInformacionDuplicados
              class="btn btn-default btn-sm"
            >
              {{ slotProps.cantidad_duplicados.cantidad_duplicados }}
            </button>
          </template>
        </registros>
      </div>
    </div>
    <div class="row animated fadeIn" v-if="nuevoGlp == 1">
      <div class="col-xl-12">
        <glp
          v-show="!proceso"
          :certificadosAsignados="certificadosAsignados"
          @cancelar="
            nuevoGlp = 0;
            duplicar = false;
          "
          @actualizar="actualizar($event)"
          @guardar="guardar($event)"
          :registro="glp"
          :nuevo="nuevo"
          :duplicar="duplicar"
          :locales="locales"
          :ingenieros="ingenieros"
        />
      </div>
    </div>
    <b-modal id="modalBuscador" title="Buscar certificado trimovil">
      <input
        type="text"
        v-model="queryConModal"
        @keyup="refrescarTabla()"
        maxlength="7"
      />
      <template #modal-footer>
        <div class="w-100">
          <router-link
            class="btn btn-primary btn-sm float-right"
            :to="'/trimovil/' + queryConModal"
            >Buscar</router-link
          >
        </div>
      </template>
    </b-modal>
    <b-modal
      id="modalInformacionDuplicados"
      size="lg"
      ok-only
      title="Información de certificados"
    >
      <table class="table table-sm table-hover">
        <thead>
          <tr>
            <th>ID</th>
            <th>CERTIFICADO</th>
            <th>FECHA REGISTRO</th>
            <th>BOLETA INFORMATIVA</th>
            <th># DE FOTOS</th>
            <th>VER FOTOS </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="info in inforCertificadoPlacaDuplicada" :key="info.Id">
            <td>{{ info.Id }}</td>
            <td>{{ info.certificado }}</td>
            <td>{{ info.fecha_registro }}</td>
            <td>
              {{ info.boleta_informativa == "1" ? "SI" : "NO" }}


              <b-form-checkbox
  :checked="getSwitchState(info)"
  @change="handleSwitchChange(info)"
  name="check-button"
  switch
></b-form-checkbox>

            </td>

            <td>
              <button
                @click="verFotos(info.codeQR)"
                type="button"
                v-b-modal.modalFotos
                class="btn btn-default"
              >
                {{ info.fotos }}
              </button>
            </td>
            <td>
              <a
                :href="
                  'https://certificadosdegasperu.com/certificado/glp/' +
                  info.Id +
                  '/2'
                "
                target="_blank"
                class="btn btn-default"
              >
                <i class="fa fa-eye"></i> Ficha
              </a>
            </td>
          </tr>
        </tbody>
      </table>
    </b-modal>
    <b-modal id="modalFotos" size="xl" ok-only  title="Fotos">
      <div class="row">
        <div v-for="foto in fotosCertificado" :key="foto.Id" class="col-lg-4">
          <a :href="URL_WEB() + foto.foto" target="_blank">
            <img
              class="img-fluid img-thumbnail"
              style="max-height: 300px; z-index: 1"
              :src="URL_WEB() + foto.foto"
              :alt="foto.descripcion"
              :title="foto.descripcion"
            />
          </a>
        </div>
      </div>
     
    </b-modal>
  </div>
</template>
<script>
import glp from "../components/compartidos/principales/Glp";
import registros from "../components/compartidos/Registros";
import procesando from "../components/compartidos/Procesando";
import personal from "../components/compartidos/SelectPersonal.vue";
import local from "../components/compartidos/SelectLocales.vue";
import anios from "../components/compartidos/SelectAnios.vue";
import meses from "../components/compartidos/SelectMeses.vue";
import dias_pendientes from "../components/compartidos/DiasPendientes.vue";
import axios from "axios";

export default {
  name: "PageGlp",
  components: {
    glp,
    registros,
    procesando,
    local,
    meses,
    anios,
    personal,
    dias_pendientes,
  },
  data() {
    return {
      tempBoletaInformativaState: {},
    // Objeto para almacenar el valor original de cada boleta_informativa
    originalBoletaInformativaState: {},
        isConfirmed: {},
      certificadosAsignados: [],
      locales: [],
      ingenieros: [],
      personaDNI: "",
      cargandoInfoDuplicado: true,
      fotosCertificado: [],
      queryConModal: "",
      cargaRegistros: true,
      localSeleccionado: "Todo",
      mesSeleccionado: "Todo",
      anioSeleccionado: "Todo",
      personalSeleccionado: "",
      proceso: false,
      nuevo: true,
      duplicar: false,
      glp: null,
      nuevoGlp: 0,
      porPagina: 10,
      inforCertificadoPlacaDuplicada: [],
      columns2: [
        {
          label: "N° Cert.",
          field: "certificado",
          width: "5%",
          thClass: "text-nowrap",
          tdClass: "text-nowrap",
        },
        {
          label: "Propietario",
          field: "propietario",
          width: "24%",
          tdClass: "text-nowrap ",
          thClass: "text-nowrap ",
        },
        {
          label: "Usuario",
          field: "nombres",
          width: "16%",
          tdClass: "text-nowrap ",
          thClass: "text-nowrap ",
        },
        {
          label: "Tipo",
          field: "tipo_usuario",
          width: "5%",
          tdClass: "text-nowrap ",
          thClass: "text-nowrap ",
        },

        {
          label: "Marca",
          field: "marca",
          width: "5%",
          tdClass: "text-nowrap ",
          thClass: "text-nowrap ",
        },
        {
          label: "Modelo",
          field: "modelo",
          width: "10%",
          tdClass: "text-nowrap ",
          thClass: "text-nowrap ",
        },
        {
          label: "Placa Rodaje",
          field: "placa_rodaje",
          width: "5%",
          tdClass: "text-center ",
          thClass: "text-center ",
        },
        {
          label: "Registros",
          field: "cantidad_duplicados",
          width: "5%",
          tdClass: "text-center ",
          thClass: "text-center ",
        },
        {
          label: "Taller Autorizado",
          field: "Taller_Autorizado",
          width: "15%",
          tdClass: "text-center ",
          thClass: "text-center ",
        },
        {
          label: "Días x Vencer",
          field: "dias_pendientes",
          width: "10%",
          tdClass: "text-center ",
          thClass: "text-center ",
        },
        {
          label: "Fecha Registro",
          field: "fecha_registro",
          width: "8%",
          tdClass: "text-center ",
          thClass: "text-center ",
        },
        {
          label: "Fecha Expiración",
          field: "fecha_expiracion",
          width: "8%",
          tdClass: "text-center ",
          thClass: "text-center ",
        },
      ],
    };
  },

  created() {
    this.verificadorUrl();
    this.cargarCertificadosAsignados();
    this.cargarLocales();
    this.cargarIngenierosFirmantes();
    if (this.$route.params.certificado != undefined) {
      this.queryConModal = this.$route.params.certificado;
    }

    setTimeout(() => {
      this.cargaRegistros = false;
    }, 1000);
  },
  methods: {
    
    cargarLocales() {
      axios
        .post(
          this.URL_BASE() +
            "personas/readDNI/" +
            this.$store.state.usuario.idpersona
        )
        .then((respuesta) => {
          if (respuesta.data.msg == "exito") {
            this.locales = respuesta.data.data;
          }
        })
        .catch((error)=> {
          console.log(error);
        });
    },
    cargarIngenierosFirmantes() {
      axios
        .get(
          this.URL_BASE() +
            "inges"        )
        .then((respuesta) => {
          if (respuesta.data.msg == "exito") {
            this.ingenieros = respuesta.data.data;
            console.log("Ingenieros cargados:", this.ingenieros);
          }
        })
        .catch((error)=> {
          console.log(error);
        });
    },
    cargarCertificadosAsignados() {
      if (this.$store.state.usuario.idtipo == 1) {
        this.personaDNI = this.$store.state.usuario.idpersona;
        axios
          .post(
            this.URL_BASE() +
              "control/verificarRangoCertificadosByDni/" +
              this.personaDNI
          )
          .then((respuesta) => {
            if (respuesta.data.msg == "exito") {
              const rango = respuesta.data.data[0];
              this.crearArrayCertificadosAsignados(
                rango["inicial"],
                rango["final"],
                rango["ultimo_certificado"]
              );
            }
          })
          .catch(function () {});
      }
    },
    obtenerNumeroFormateado(num) {
      return num.toString().padStart(6, "0"); // Completa con ceros hasta 6 dígitos
    },
    crearArrayCertificadosAsignados(inicio, fin, ultimoCertificado) {
      if (
        (ultimoCertificado != 0 && ultimoCertificado > inicio) ||
        inicio == ultimoCertificado
      ) {
        inicio = Number(ultimoCertificado) + 1;
      }
      this.certificadosAsignados = [];
      for (let index = inicio; index <= fin; index++) {
        this.certificadosAsignados.push(this.obtenerNumeroFormateado(index));
      }
    },
    cargaForzada() {
      setTimeout(() => {
        this.refrescarTabla();
      }, 100);
    },
    refrescarTabla() {
      this.$refs.registros.loadItems();
    },
    cargandoInfoPlacaDuplicada(placa) {
      this.inforCertificadoPlacaDuplicada = [];
      this.cargandoInfoDuplicado = true;
      axios
        .post(this.URL_BASE() + "glp/info_detalle_duplicados_placa/" + placa)
        .then((respuesta) => {
          if (respuesta.data.msg == "exito") {

 this.inforCertificadoPlacaDuplicada = respuesta.data.data.map(info => {
          return {
            ...info,
            boleta_informativa: info.boleta_informativa == 1 // Convertir 1 a true y 0 a false
          };
        });


          //  this.inforCertificadoPlacaDuplicada = [...respuesta.data.data];
          }
          this.cargandoInfoDuplicado = false;
        })
        .catch(function () {
          this.cargandoInfoDuplicado = false;
        });
    },
    verFotos(codeQR) {
      this.fotosCertificado = [];
      axios
        .post(this.URL_BASE() + "fotos/read/" + codeQR)
        .then((respuesta) => {
          if (respuesta.data.msg == "exito") {
            this.fotosCertificado = [...respuesta.data.data];
          }
        })
        .catch((error)=> {});
    },
    actualizar(registro) {
      this.proceso = true;
      axios
        .put(this.URL_BASE() + "glp/update/", registro)
        .then((respuesta) => {
          this.refrescarTabla();
          if (respuesta.data.msg == "exito") {
            this.exito("Glp actualizado correctamente");
          }
          if (respuesta.data.msg == "repetido") {
            this.advertencia(
              "¡El certificado N°: " + respuesta.data.data + " ya existe!"
            );
          }
          this.proceso = false;
        })
        .catch((error)=> {
          console.log(error);
        });
    },
    guardar(registro) {
      this.proceso = true;
      axios
        .post(this.URL_BASE() + "glp/create/", registro)
        .then((respuesta) => {
          this.refrescarTabla();
          if (respuesta.data.msg == "exito") {
            this.cargarCertificadosAsignados();
            this.exito("Glp actualizado correctamente");
            this.nuevo = false;
            this.duplicar = false;
            this.glp = {
              ...respuesta.data.dataAdicional[0],
            };
          }
          if (respuesta.data.msg == "repetido") {
            this.advertencia(
              "¡El certificado N°: " + respuesta.data.data + " ya existe!"
            );
          }

          this.proceso = false;
        })
        .catch((error)=> {
          console.log(error);
        });
    },
    confirmar(registros) {
      this.$swal({
        title: "¿Estás seguro?",
        text: "¡Los registros seleccionados se eliminarán!",
        type: "warning",
        showCancelButton: true,
        buttonsStyling: false,
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        confirmButtonClass: "btn m-r-5 btn-warning",
        cancelButtonClass: "btn btn-default",
      }).then((result) => {
        if (result.value) {
          this.eliminar(registros);
          return true;
        } else if (result.dismiss) {
          return false;
        }
      });
    },
    eliminar(registros) {
      this.proceso = true;
      axios
        .post(this.URL_BASE() + "glp/delete", registros)
        .then((respuesta) => {
          if (respuesta.data.msg == "exito") {
            this.$swal("Proceso completado", "", "success");
          }
          this.proceso = false;
        })
        .catch((error)=> {
          console.log(error);
        });
    },
    verificadorUrl() {
      let anio = this.$route.params.anio;
      let mes = this.$route.params.mes;
      let idpersona = this.$route.params.idpersona;
      if (mes != undefined) {
        this.porPagina = -1;
        this.mesSeleccionado = parseInt(mes);
        this.anioSeleccionado = anio;
      }
      if (idpersona == "Todo" || idpersona == undefined) {
        if (this.$store.state.usuario.idtipo == 2) {
          this.personalSeleccionado = "Todo";
        } else {
          this.personalSeleccionado = this.$store.state.usuario.idpersona;
        }

        //
      } else {
        this.personalSeleccionado = idpersona;
      }
    },
    getSwitchState(info) {
    // Si no se ha almacenado un valor temporal para este registro, asignamos el valor inicial
    if (!this.tempBoletaInformativaState[info.Id]) {
      this.$set(this.tempBoletaInformativaState, info.Id, info.boleta_informativa);
    }
    // Devuelve el valor temporal que controla el switch
    return this.tempBoletaInformativaState[info.Id];
  },
    handleSwitchChange(info){
  // Guardamos el valor original de boleta_informativa antes de cambiarlo
    const valorOriginal = info.boleta_informativa;
      const originalTempValue = this.tempBoletaInformativaState[info.Id];
     // Actualizamos el estado temporal para reflejar el cambio visual
    this.$set(this.tempBoletaInformativaState, info.Id, !originalTempValue);

    // Cambiamos temporalmente el estado visual del switch
      this.$swal({
        title: "¿Estás seguro?",
        text: "¡La boleta informativa se modificará!",
        type: "warning",
        showCancelButton: true,
        buttonsStyling: false,
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        confirmButtonClass: "btn m-r-5 btn-warning",
        cancelButtonClass: "btn btn-default",
      }).then((result) => {
        if (result.value) {
            this.actualizarBoletaInformativa(info);
        info.boleta_informativa = !valorOriginal; // Cambiar el valor original
        this.$set(this.tempBoletaInformativaState, info.Id, info.boleta_informativa);
       } else  {
       this.$set(this.tempBoletaInformativaState, info.Id, originalTempValue);
        }
      });
    },
    actualizarBoletaInformativa(info){
        this.proceso = true;
      axios
        .put(this.URL_BASE() + "glp/update_boleta_informativa/", info)
        .then((respuesta) => {
          this.refrescarTabla();
          if (respuesta.data.msg == "exito") {
            this.exito("Boleta informativa actualizado correctamente");
          }
          this.proceso = false;
        })
        .catch((error)=> {
          console.log(error);
        });
    },
    erorrdemesanje(){
      console.log('hola');
      
    }
  },
 
};
</script>